import i18n from './i18n';

export const t = (...args) => i18n.global.t(...args);
export const getLocale = () => i18n.global.locale.value;
export const setLocale = (val) => {
  i18n.global.locale.value = val;
};
